export default __webpack_public_path__ + "static/media/classic3.4985edce.jpg";